import {AxiosError} from "axios";

/** POST shift/start when shift is already active (misleading API copy). */
export function isShiftAlreadyStartedError(error: unknown): boolean {
  if (!(error instanceof AxiosError)) {
    return false;
  }
  if (error.response?.status !== 400) {
    return false;
  }
  const message = String(
    (error.response.data as {message?: string} | undefined)?.message ?? "",
  ).toLowerCase();
  return message.includes("scheduled to start");
}
